
const 	$ = jQuery;

import '../lib/stacktable.js';

$('.js-bookings-table').stacktable();